import React from 'react'

const ItemSelectableWithCheck = ({ children, checked, onChange, name, disabled }) => {
  return (
    <div className='white-bg shadow rounded-4 pt-3 pb-3 ps-4 pe-4'>
      <div className="d-flex align-items-end justify-content-between gap-2">
        {children}
        <div className="form-check">
          <input
            id={"flexCheckDefault"}
            className="form-check-input"
            type="checkbox"
            checked={checked}
            name={name}
            onChange={onChange}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  )
}

export default ItemSelectableWithCheck